import { randomNumber } from '@perch-labs/warbler';
import { UTILITY_IDS } from '~/utils/constants';

export const setValueByName = (name: string, value: string) => {
  const element = document.getElementsByName(name)[0] as HTMLInputElement;
  if (!element) return;
  const lastValue = element.value;
  element.value = value;
  const event = new Event('change', { bubbles: true });
  // @ts-expect-error _valueTracker set by React
  const tracker = element._valueTracker;
  if (tracker) tracker.setValue(lastValue);
  element.dispatchEvent(event);
};

export const generateAccountNumber = (utilityId: number): string => {
  try {
    // PEPCO DC account numbers are 11 digits.
    if (utilityId === UTILITY_IDS['PEPCO DC']) {
      return `${randomNumber(11)}`;
    }

    // Xcel Energy MN account numbers match ^51[0-9]{8,11}$
    if (utilityId === UTILITY_IDS['Xcel Energy MN']) {
      return `51${randomNumber(8)}`;
    }

    let [, pattern] =
      document.querySelector('form p[class*=Requirements]')?.textContent?.split('Example: ') || [];

    if (pattern) {
      pattern = pattern.split(',')[0].replace(/(-)|(\s+)/g, '');
      if (
        utilityId === UTILITY_IDS['Eversource / NSTAR'] ||
        utilityId === UTILITY_IDS['Consolidated Edison NY']
      ) {
        return `${2}${randomNumber(pattern.length - 1)}`;
      } else if (utilityId === UTILITY_IDS['Eversource / WMECO']) {
        return `${5}${randomNumber(pattern.length - 1)}`;
      } else {
        return `${randomNumber(pattern.length)}`;
      }
    }
    return `${randomNumber(10)}`;
  } catch (e) {
    return '';
  }
};
